/**
 * @author xyguo
 * @description 在线课程管理页面,展示所有在线课程信息
 * @Date 2020/1/20
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool, component_tool } from '../../../tool'
let { WizContainer, WizReduxTemplate, modelUtils } = framework_tool;
let { WizBrowserExport, WizSpin, WizModal } = component_tool;

const formateProgramSource = (programSource) => {
  let programSourceStr = '';
  let dict = [
    { code: 1, codeName: "别克销售" },
    { code: 2, codeName: "雪佛兰销售" },
    { code: 3, codeName: "凯迪拉克销售" },
    { code: 4, codeName: "售后技术" },
    { code: 5, codeName: "售后非技术" },
    { code: 6, codeName: "二手车" },
    { code: 7, codeName: "凯迪新能源" },
    { code: 8, codeName: "集团销售" },
    { code: 9, codeName: "校企合作" },
    { code: 10, codeName: "融入辅导_相达" },
    { code: 11, codeName: "融入辅导_申先" },
    { code: 12, codeName: "TAC技术支持" },
    { code: 13, codeName: "其它" },
    { code: 14, codeName: "车工坊" },
    { code: 15, codeName: "德科" },
    { code: 19, codeName: "别克新能源" }
  ];
  dict.forEach(e => {
    if (e.code === programSource) {
      programSourceStr = e.codeName
    }
  })
  return programSourceStr
}

class ProgramList extends WizContainer {

  componentName = 'ProgramList';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }



  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '课程名称',
        field: 'programName',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '课程编码',
        field: 'programScoId',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '申请类型',
        field: 'applyTypeCh',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '新版本号',
        field: 'versionNumber',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '状态',
        field: 'statusCh',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '申请人',
        field: 'applicantFullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '培训公司',
        field: 'trainCompanyName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '申请时间',
        field: 'createTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '修改申请时间',
        field: 'applyTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '处理申请时间',
        field: 'handleTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },

    ]
    if (o['success']) {
      let data = o['data']

      let _data = []
      data && data.forEach(d => {
        let _d = { ...d }
        let authData = d['authData']
        let target = ''
        if (authData && Object.keys(authData)) {
          if (authData['orgIds'] && authData['orgIds'].length) {
            target += ' 组织范围：'
            authData['orgIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['positionIds'] && authData['positionIds'].length) {
            target += ' 岗位：'
            authData['positionIds'].forEach(org => {
              let entityName = org['positionBrandName'] ? org['positionBrandName'] : org['name']
              target += entityName + ','
            });
            target += '\n'
          }
          if (authData['positionCategoryIds'] && authData['positionCategoryIds'].length) {
            target += ' 岗位分类：'
            authData['positionCategoryIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['personIds'] && authData['personIds'].length) {
            target += ' 指定人员：'
            authData['personIds'].forEach(org => {
              target += org['userName'] + '(' + org['fullName'] + '),'
            });
            target += '\n'
          }
        }
        _d['programSource'] = formateProgramSource(d['programSource'])
        _d['scope'] = target
        _data.push(_d)
      });

      WizBrowserExport({
        title: '课程申请信息',
        sheetName: '课程申请信息',
        columns: columnDefs.filter((_, index) => index),
        rows: _data,
        filename: '课程申请信息.xlsx',
      })
      // wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _saveAuth = (values, changeModal) => {
    this.setState({
      changeModal: changeModal
    })
    this.doAction({
      path: "whitelist/save",
      payload: {
        key: "whitelist@save",
        apiParams: values
      }
    })
  }

  putOperate = (values) => {
    this.doAction({
      path: "courseApplication/operate",
      payload: {
        key: "courseApplication@operate",
        apiParams: values
      }
    })
  }

  // 监听属性和状态的变化
  propsAndStateOnChange = {
    authInfo: this._authInfoOver.bind(this),
    operateData: this._operateDataOver.bind(this),
  };

  _operateDataOver(nextProps, nextState) {
    const { operateData } = nextProps;
    if (operateData.success) {
      wizNotice.success('保存成功');
      return true;
    } else {
      wizNotice.error(operateData.msg);
    }
    return false;
  }

  _authInfoOver(nextProps, nextState) {
    const { authInfo } = nextProps;
    if (authInfo.success) {
      wizNotice.success('保存成功');
      nextState.changeModal(false, true, true)
      return true;
    }
    return false;
  }
  //选择模版后下一步
  _addSurveyByTempSubmit = (obj, e) => {
    if (obj?.valueRows[0]?.id) {
      this.jumpPage('push', '/course/courseUpdateApplication', { id: obj.valueRows[0]?.id })
    }
  }

  _onCancelTemp = (e) => {

  };

  operateFun = (record, operateStatus) => {
    WizModal.confirm({
      title: operateStatus == 0 ? '您正在创建此申请的在线课程，是否确认？' :
        (operateStatus == 1 ? '您正在做确认申请操作，是否确定？'
          :
          '您正在做取消申请操作，是否确定？'),
      onOk: () => {
        this.putOperate({ id: record.id, operateStatus: operateStatus })
      },
      onCancel() { }
    })
  }
  lookJump = (record) => {
    if (record.applyType == 0) {
      this.jumpPage('push', '/course/applicationView', { id: record.id })
    } else {
      this.jumpPage('push', '/course/applicationUpdateView', { id: record.id })
    }
  }
  editApplication = (record) => {
    if (record.applyType == 0) {
      this.jumpPage('push', '/course/applicationDetailUpd', { id: record.id, programId: record.programId })
    } else {
      this.jumpPage('push', '/course/courseUpdateApplicationUpd', { id: record.id })
    }
  }
  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig({ self: this }),
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        delete: this._handleCMD,
        enable: this._handleCMD,
        UpdateProgramStatus: (nextProps, nextState, key) => {
          let o = nextProps[key]
          if (o['success']) {
            wizNotice.success(o['msg']);
            let bizIds = o['data']
            if (bizIds) {
              if (bizIds > 0) {

                WizModal.confirm({
                  title: '注意', content: "消息通知内容有变更，是否重新发送消息通知", cancelText: "否", okText: "是",
                  onOk: () => {
                    this.doAction({
                      path: "notice/sendNotice",
                      payload: {
                        key: "sendNoticeKey",
                        apiParams: {
                          bizId: bizIds,
                          bizType: 0,
                          resend: true
                        },
                      },
                    })
                  },
                  onCancel: () => {
                    this.doActions([
                      {
                        path: "notice/sendNotice",
                        payload: {
                          key: "sendNoticeKey",
                          apiParams: {
                            bizId: bizIds,
                            bizType: 0,
                            resend: false
                          },
                        },
                      },
                    ]);
                  }
                });
              } else {

                this.doActions([
                  {
                    path: "notice/sendNotice",
                    payload: {
                      key: "sendNoticeKey",
                      apiParams: {
                        bizId: 0 - bizIds,
                        bizType: 0,
                        resend: false
                      },
                    },
                  },
                ]);
              }
            }
            return true;
          } else {
            wizNotice.error(o['msg']);
            return false;
          }
        },
        export: this._handleFile
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  let { whitelist, courseApplication } = state
  const authInfo = modelUtils.getModelEntity(whitelist, 'whitelist@save');
  const operateData = modelUtils.getModelEntity(courseApplication, 'courseApplication@operate');
  const load = modelUtils.getLoadingState(state, 'whitelist')
  return {
    authInfo,
    operateData,
    ...load
  }
};

export default connect(mapStateToProps)(ProgramList);
